document.addEventListener('DOMContentLoaded', function () {
    //console.log('DOM Content Loaded - Initializing Product Swipers');

    // Initialize product image swiper
    const productSwipers = {};

    // Function to load Swiper CSS
    function loadSwiperCSS() {
        if (document.querySelector('link[href*="swiper-bundle.min.css"]')) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
            link.onload = resolve;
            document.head.appendChild(link);
        });
    }

    // Function to initialize product swiper

    // Debug version with extensive logging
    async function initializeProductSwiper(productContainer) {
        await new Promise((resolve) => setTimeout(resolve, 100));

        const productId = productContainer.id.replace('product-item-', '');
        const swiperElement = productContainer.querySelector(`.swiper-product-${productId}`);

        if (!swiperElement) {
            return;
        }

        if (swiperElement.swiper) {
            swiperElement.swiper.destroy(true, true);
        }

        await loadSwiperCSS();

        try {
            const slides = swiperElement.querySelectorAll('.swiper-slide');

            if (slides.length === 0) {
                return;
            }

            if (slides.length === 1) {
                // Hide pagination and navigation for single slides
                const pagination = swiperElement.querySelector(`.swiper-pagination-${productId}`);
                const nextBtn = swiperElement.querySelector(`.swiper-button-next-${productId}`);
                const prevBtn = swiperElement.querySelector(`.swiper-button-prev-${productId}`);

                if (pagination) pagination.style.display = 'none';
                if (nextBtn) nextBtn.style.display = 'none';
                if (prevBtn) prevBtn.style.display = 'none';
                return;
            }

            // Find navigation and pagination elements
            const nextBtn = swiperElement.querySelector(`.swiper-button-next-${productId}`);
            const prevBtn = swiperElement.querySelector(`.swiper-button-prev-${productId}`);
            const pagination = swiperElement.querySelector(`.swiper-pagination-${productId}`);

            productSwipers[productId] = new Swiper(swiperElement, {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: false,
                threshold: 1,
                touchRatio: 1,

                // Essential for nested swipers
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                nested: true,

                // Touch and interaction settings
                allowTouchMove: true,
                simulateTouch: true,

                // Prevent outer swiper movement
                stopPropagation: true,
                touchMoveStopPropagation: true,

                // Touch handling settings
                touchStartPreventDefault: false,
                touchStartForcePreventDefault: false,

                // Click settings
                preventClicks: false,
                preventClicksPropagation: false,
                slideToClickedSlide: false,

                // Resistance settings
                resistance: true,
                resistanceRatio: 0.3,

                // Navigation with unique selectors
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                    disabledClass: 'swiper-button-disabled',
                    hiddenClass: 'swiper-button-hidden',
                },

                // Pagination with unique selector
                pagination: {
                    el: pagination,
                    clickable: true,
                    dynamicBullets: false,
                    bulletClass: 'swiper-pagination-bullet',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    renderBullet: function (index, className) {
                        return `<span class="${className}" data-product="${productId}" data-slide="${index}"></span>`;
                    },
                },

                // Event handlers
                on: {
                    init: function () {
                        const paginationEl = swiperElement.querySelector(`.swiper-pagination-${productId}`);
                        if (paginationEl) {
                            paginationEl.style.display = 'block';
                        }
                        updatePaginationDots(this, productId);

                        // Force update after initialization
                        this.update();
                        this.updateSize();
                        this.updateSlides();
                    },
                    slideChange: function () {
                        updatePaginationDots(this, productId);
                        if (typeof resetColorSelection === 'function') {
                            resetColorSelection(productId);
                        }
                    },
                    // touchStart: function() {
                    //     // Disable all links in slides
                    //     this.slides.forEach(slide => {
                    //         const links = slide.querySelectorAll('a, [href]');
                    //         links.forEach(link => {
                    //             link.style.pointerEvents = 'none';
                    //         });
                    //     });
                    // },
                    
                    touchEnd: function(swiper, event) {
                        // Re-enable links after a short delay
                        setTimeout(() => {
                            this.slides.forEach(slide => {
                                const links = slide.querySelectorAll('a, [href]');
                                links.forEach(link => {
                                    link.style.pointerEvents = 'auto';
                                });
                            });
                        }, 100);
                    },
                    
                    sliderMove: function() {
                        // Keep links disabled during movement
                        this.slides.forEach(slide => {
                            const links = slide.querySelectorAll('a, [href]');
                            links.forEach(link => {
                                link.style.pointerEvents = 'none';
                            });
                        });
                    }
                },
            });

            // Function to update pagination dots
            function updatePaginationDots(swiper, productId) {
                if (!swiper.pagination || !swiper.pagination.bullets) {
                    return;
                }

                const bullets = swiper.pagination.bullets;
                const activeIndex = swiper.realIndex;
                const totalSlides = bullets.length;

                if (totalSlides <= 3) {
                    // Show all bullets if 3 or fewer
                    bullets.forEach((bullet) => {
                        bullet.style.display = 'inline-block';
                    });
                } else {
                    // Hide all bullets first
                    bullets.forEach((bullet) => {
                        bullet.style.display = 'none';
                    });

                    // Show only three bullets: previous, active, and next
                    if (totalSlides > 0) {
                        bullets[activeIndex].style.display = 'inline-block'; // Active bullet
                        if (totalSlides > 1) {
                            bullets[(activeIndex - 1 + totalSlides) % totalSlides].style.display = 'inline-block'; // Previous bullet
                        }
                        if (totalSlides > 2) {
                            bullets[(activeIndex + 1) % totalSlides].style.display = 'inline-block'; // Next bullet
                        }
                    }
                }
            }

            // Initialize pagination dots
            setTimeout(() => {
                if (productSwipers[productId]) {
                    updatePaginationDots(productSwipers[productId], productId);

                    // Store original images after swiper initialization
                    if (typeof storeOriginalImages === 'function') {
                        storeOriginalImages(productContainer);
                    }

                    // Initialize color swatch handlers
                    if (typeof initializeColorSwatches === 'function') {
                       
                        const parentContainer = productContainer.closest('.card'); // or whatever the parent class is
                        if(parentContainer){
                            const swatchContainer = parentContainer.querySelector('.product-variants');
                            initializeColorSwatches(swatchContainer);
                        }
                        
                       
                    }

                    // Force final update
                    productSwipers[productId].update();
                    productSwipers[productId].updateSize();
                    productSwipers[productId].updateSlides();
                }
            }, 50);

        } catch (error) {
            console.error('Error initializing Swiper for product:', productId, error);
        }
    }
    // Function to store original images
    function storeOriginalImages(container) {
        const images = container.querySelectorAll('.product-item__image-figure img, .swiper-slide img');
        images.forEach((img) => {
            if (!img.hasAttribute('data-original-image')) {
                img.setAttribute('data-original-image', img.src);
                img.setAttribute('data-original-srcset', img.srcset || '');
            }
        });
    }

    // Function to initialize color swatches
    function initializeColorSwatches(container) {
        
        
        if(container)
        {
            const colorSwatches = container.querySelectorAll('.color-swatch');
            colorSwatches.forEach((swatch) => {
                if (!swatch.hasAttribute('data-initialized')) {
                    swatch.addEventListener('click', handleColorSwatchClick);
                    swatch.setAttribute('data-initialized', 'true');
                }
            });
        }
    }

    // Function to handle color swatch clicks
    function handleColorSwatchClick(event) {
        const swatch = event.target.closest('.color-swatch');
        if (!swatch) return;

        const cardContainer = swatch.closest('.card');
        const productContainer = cardContainer.querySelector('[id^="product-item-"]');
       
        const productId = productContainer.id.replace('product-item-', '');

        // Remove selected class from all swatches in this card. Swatches
        // live in .card-information (sibling of productContainer), so
        // deselecting must scope to cardContainer, not productContainer.
        cardContainer.querySelectorAll('.color-swatch').forEach((s) => {
            s.classList.remove('selected');
        });

        // Add selected class to clicked swatch
        swatch.classList.add('selected');

        // Update selected value text if it exists
        const selectedValueElement = productContainer.querySelector('.selected-value');
        if (selectedValueElement) {
            selectedValueElement.textContent = swatch.getAttribute('data-value') || '';
        }

        // Fetch the data-value of the selected color swatch
        const selectedColorValue = swatch.getAttribute('data-value');

        // Find the corresponding images in the Swiper slider
        const slides = productContainer.querySelectorAll('.swiper-slide img');
        let firstMatchingImageIndex = -1;
        const matchingImages = [];

        // Bidirectional substring match — handles cases where the option
        // value carries a size prefix the alt text omits, e.g.
        // option="650ML CLAY BEIGE" + alt="Clay Beige" should still match.
        const lcSel = (selectedColorValue || '').toLowerCase();
        slides.forEach((img, index) => {
            const lcAlt = (img.alt || '').toLowerCase();
            const hit = lcAlt && lcSel && (lcAlt.indexOf(lcSel) !== -1 || lcSel.indexOf(lcAlt) !== -1);
            if (hit) {
                if (firstMatchingImageIndex === -1) {
                    firstMatchingImageIndex = index;
                }
                matchingImages.push(img);
            }
        });

        // If no slide matched, leave the gallery as-is so the card never
        // goes blank — the alt-text matching is best-effort, not required.
        if (matchingImages.length === 0) {
            return;
        }

        // Hide all images first
        slides.forEach((img) => {
            img.parentElement.style.display = 'none'; // Hide the slide
        });

        // If matching images were found, show them
        if (matchingImages.length > 0) {
            // Show the first matching image
            slides[firstMatchingImageIndex].parentElement.style.display = 'block'; // Show the first matching slide

            // Show the next images in the Swiper
            for (let i = firstMatchingImageIndex + 1; i < slides.length; i++) {
                if (slides[i].alt === selectedColorValue) {
                    slides[i].parentElement.style.display = 'block'; // Show subsequent matching slides
                }
            }

            // Show all remaining images after the matched images
            for (let i = 0; i < slides.length; i++) {
                if (i < firstMatchingImageIndex || slides[i].alt !== selectedColorValue) {
                    slides[i].parentElement.style.display = 'block'; // Show all other images
                }
            }

            const swiperInstance = productSwipers[productId];
            if (swiperInstance) {
                swiperInstance.slideTo(firstMatchingImageIndex); // Slide to the first matching image
                // Note: previously a `slideChange` listener was attached here
                // to deselect the swatch when the user manually swiped away.
                // Each click added a NEW listener (never detached) bound to
                // that click's `swatch` via closure, so old listeners would
                // fire on later transitions and incorrectly clear the
                // `.selected` class on the currently-active swatch. The
                // selected state should reflect the user's last click intent;
                // manual swipes leave it as-is.
            }
        }
    }

    // Function to reset color selection
    function resetColorSelection(productId) {
        const productContainer = document.getElementById(`product-item-${productId}`);
        if (!productContainer) return;

        const selectedValueElement = productContainer.querySelector('.selected-value');
        if (selectedValueElement) {
            selectedValueElement.textContent = '';
        }

        resetProductImages(productId);
    }

    // Function to reset product images
    function resetProductImages(productId) {
        const productContainer = document.getElementById(`product-item-${productId}`);
        if (!productContainer) return;

        const originalImages = productContainer.querySelectorAll('[data-original-image]');
        originalImages.forEach((img) => {
            const originalSrc = img.getAttribute('data-original-image');
            const originalSrcset = img.getAttribute('data-original-srcset');

            if (originalSrc) {
                img.src = originalSrc;
                img.srcset = originalSrcset;
            }
        });

        if (productSwipers[productId]) {
            productSwipers[productId].update();
        }
    }

    // Helper function to fix swiper dimensions if they're 0
    function fixSwiperDimensions(swiper, productId) {
        const swiperEl = swiper.el;
        if (swiperEl.offsetWidth === 0 || swiperEl.offsetHeight === 0) {
            //console.log('Fixing swiper dimensions for product:', productId);

            // Force dimensions
            swiperEl.style.width = '300px';
            swiperEl.style.height = '300px';

            // Update swiper
            swiper.update();
            swiper.updateSize();
            swiper.updateSlides();
        }
    }

    // Initialize everything
    async function init() {
        //console.log('Initializing all components');
        const productContainers = document.querySelectorAll('.product-item');
        //console.log('Found product containers:', productContainers.length);

        for (const container of productContainers) {
            await initializeProductSwiper(container);
        }

        // Fix dimensions after initialization
        setTimeout(() => {
            Object.entries(productSwipers).forEach(([productId, swiper]) => {
                if (swiper && swiper.el) {
                    fixSwiperDimensions(swiper, productId);
                }
            });
        }, 500);
    }

    // Function to handle newly loaded products
    async function handleNewProducts(container) {
        await new Promise((resolve) => setTimeout(resolve, 200));

        if (container.classList.contains('product-item')) {
            await initializeProductSwiper(container);
        } else {
            const productItems = container.querySelectorAll('.product-item');
            for (const item of productItems) {
                await initializeProductSwiper(item);
            }
        }
    }

    window.handleNewProducts = handleNewProducts;

    // Initialize on page load
    init();

    // Create Intersection Observer for lazy loading
    const lazyLoadObserver = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    handleNewProducts(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            root: null,
            rootMargin: '50px',
            threshold: 0.1,
        }
    );

    // Handle dynamic content loading
    const productGridObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    if (node.classList.contains('product-item')) {
                        //console.log('New product item detected:', node.id);
                        lazyLoadObserver.observe(node);
                    } else {
                        const productItems = node.querySelectorAll('.product-item');
                        productItems.forEach((item) => {
                            lazyLoadObserver.observe(item);
                        });
                    }
                }
            });
        });
    });

    // Start observing the product grid
    const productGrid =
        document.querySelector('#CollectionProductGrid') ||
        document.querySelector('.product-grid') ||
        document.body;

    productGridObserver.observe(productGrid, {
        childList: true,
        subtree: true,
    });

    // Observe existing products for lazy loading
    document.querySelectorAll('.product-item').forEach((item) => {
        lazyLoadObserver.observe(item);
    });

    //console.log('Observer setup complete');
    
});



   
